module.exports = __webpack_public_path__ + "media/app/containers/DashboardPage/GREETINGS.edf07209.svg";